import Vue from 'vue'
import axios from '@/plugins/axios'

export const find = async ({ commit }, params = {}) => {
  try {
    const { data } = await axios.get('list-automation', { params })

    if (data && data.lists) {
      commit('setRows', data.lists)
      return data.lists
    }

    commit('setRows', [])
    return []
  } catch (err) {
    console.error('Erro ao buscar listas de automação:', err)
    commit('setRows', [])
    return []
  }
}

export const findById = async ({ commit }, id) => {
  try {
    const { data } = await axios.get(`list-automation/${id}`)

    if (data && data.listAutomation) {
      commit('setRow', data.listAutomation)
      return data.listAutomation
    }

    return null
  } catch (err) {
    return err
  }
}

export const create = async (_, body) => {
  Vue.prototype.$loading(true)

  try {
    const { status } = await axios.post('list-automation', body)

    return status
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const update = async (_, { id, body }) => {
  Vue.prototype.$loading(true)

  try {
    const { status } = await axios.put(`list-automation/${id}`, body)

    return status
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const remove = async (_, id) => {
  Vue.prototype.$loading(true)

  try {
    const { status } = await axios.delete(`list-automation/${id}`)

    return status
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const findLeadsByListId = async ({ commit }, listId) => {
  try {
    const { data } = await axios.get(`list-automation/${listId}/leads`)

    if (data && data.leads) {
      return data.leads
    }

    return []
  } catch (err) {
    console.error('Erro ao buscar leads da lista:', err)
    return []
  }
}

export const updateLead = async (_, { leadId, body }) => {
  Vue.prototype.$loading(true)

  try {
    const { status } = await axios.put(
      `list-automation/leads/${leadId}`,
      body,
    )

    return status
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const removeLead = async (_, leadId) => {
  Vue.prototype.$loading(true)

  try {
    const { status } = await axios.delete(`list-automation/leads/${leadId}`)

    return status
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}
